export const calculateBudgetProgress = (
  used?: number,
  amount?: number | null,
): number => {
  return parseFloat((((used ?? 0) / (amount ?? 1)) * 100).toFixed(2));
};
